import "./Header.css";

const Header = () => {
  return <div className="header">Text Crawler</div>;
};

export default Header;
